export default "__VITE_ASSET__q7U31GhE__"